import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.Auth.ProfileSetup.Email.PreAhaMoment.FirstScreen', {
    titlePath1: 'Reduce approval time: get documents to the right people automatically',
    titlePath2: 'Improve financial controls: Send documents to the right people and track spending effectively',
    titlePath3: 'Strengthen financial controls: make sure documents go to the right people and keep track of spending',

    xero: 'Xero',
    quickBooksOnline: 'QuickBooks Online',
    oracleNetSuite: 'Oracle NetSuite',
    cin7Core: 'Cin7 Core',
    otherGL: 'your GL',

    block1: 'Choose any type of documents (bills, POs, etc.)',
    block2: 'Set multiple approval levels (Dept, CEO, etc.)',
    block3: 'Add as many users as you need',
    block4: 'Create rules with multiple conditions',
    block5: 'Sync information with {name} instantly',

    goToSetup: 'Go to setup',
    next: 'Next',
});
